var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalFlip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3959_1031)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 0 24)",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7273 10V8.66667H16.4545V10H17.7273ZM10.0909 7.33333V6H8.81818V7.33333H10.0909ZM7.54545 18H16.4545C17.1545 18 17.7273 17.4 17.7273 16.6667V14H16.4545V16.6667H7.54545V14H6.27273V16.6667C6.27273 17.4 6.84545 18 7.54545 18ZM6.27273 7.33333H7.54545L7.54545 6C6.84545 6 6.27273 6.6 6.27273 7.33333ZM19 12.6667V11.3333H5V12.6667H19ZM15.1818 7.33333V6H13.9091V7.33333H15.1818ZM7.54545 10V8.66667H6.27273L6.27273 10H7.54545ZM12.6364 7.33333V6H11.3636V7.33333H12.6364ZM17.7273 7.33333C17.7273 6.6 17.1545 6 16.4545 6V7.33333H17.7273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3959_1031",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3959_1031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3959_1031",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalFlip);
export default __webpack_public_path__ + "static/media/vertical_flip.d56b3b5e264e80e07c9485a969f7d69c.svg";
export { ForwardRef as ReactComponent };